const pages = {
  access_levels: {
    create: 'Create an access level',
    edit: 'Edit an access level',
  },
  controllers: {
    activate: 'Activate a controller',
    edit: 'Edit a controller',
  },
  credentials: {
    create: 'Create a credential',
    edit: 'Edit a credential',
  },
  doors: {
    edit: 'Edit a door',
  },
  holidays: {
    create: 'Create holidays',
    edit: 'Edit holidays',
  },
  inputs: {
    edit: 'Edit an input',
  },
  interlocks: {
    create: 'Create an interlock',
    edit: 'Edit an interlock',
  },
  outputs: {
    edit: 'Edit an output',
  },
  schedules: {
    create: 'Create a schedule',
    edit: 'Edit a schedule',
  },
  sites: {
    create: 'Create a site',
  },
  users: {
    create: 'Create a user',
    edit: 'Edit a user',
  },
};

export default pages;
